import React from "react";
import { cn } from "../../lib/cn";

/** Green glowing kicker with a leading rule (Aurora signature). */
export function Eyebrow({ className, children, ...props }) {
  return (
    <span className={cn("kicker", className)} {...props}>
      {children}
    </span>
  );
}

export default Eyebrow;
